import { ARTIST_LOADING, ARTIST_LOADED } from 'actions/types';
import handleApiCall from 'actions/handleApiCall';


export const getArtist = (pageid) => async (dispatch) => {
  const encodedPageId = encodeURIComponent(pageid);
  dispatch({ type: ARTIST_LOADING });
  const { data } = (await handleApiCall('get', `/api/getArtist?pageid=${encodedPageId}`)) || {};
  if (!data) {
    const newArtist = {
      data: await getArtistByMbid(pageid),
      isNew: true,
    };
    dispatch({ type: ARTIST_LOADED, data: newArtist });
  } else {
    dispatch({ type: ARTIST_LOADED, data });
  }
};

export const getArtistDiscovery = async () => {
  // 4 random, 4 trending, 4 top, 4 new
  const response = await handleApiCall('get', `/api/artists/discover`);

  return response.data;
};

export const getArtistByMbid = async (id) => {
  const { data = [] } = await handleApiCall('get', `/api/artists/mbid?mbid=${id}`);
  return data;
  // dispatch({ type: GET_ARTIST_BY_MBID, data });
};

export const requestNewArtist = async (artist) => {
  const { data = [] } = await handleApiCall('post', `/api/artists/request`, artist);
  return data;
};
